/**
 * Consent constants — shared by the site-terms and marketing consent flows.
 *
 * Consent lives on `ClientsV2/{makat}` (the business), never on `Users/{uid}`:
 *   siteTerms: { accepted, acceptedAt, acceptedBy, source }
 *   marketing: { consent, answered, answeredAt, answeredBy, source, unsubscribedAt? }
 *
 * `unsubscribedAt` is stamped when the customer clicks the unsubscribe link in a marketing
 * WhatsApp message (server-side, functions/Marketing/unsubscribe.js) and is preserved across
 * later re-approvals so the "when" is never lost.
 */
export const CONSENT_SOURCE = Object.freeze({
  APP: 'app',
  B2B_FORM: 'b2b-form',
  ADMIN: 'admin',
  /** Customer removed themselves via the link in a WhatsApp message (no login) */
  WHATSAPP_UNSUBSCRIBE: 'whatsapp-unsubscribe',
})

export const CONSENT_SOURCE_LABELS = Object.freeze({
  [CONSENT_SOURCE.APP]: 'באפליקציה',
  [CONSENT_SOURCE.B2B_FORM]: 'מהטופס',
  [CONSENT_SOURCE.ADMIN]: 'טלפונית / ידני',
  [CONSENT_SOURCE.WHATSAPP_UNSUBSCRIBE]: 'הסרה עצמית מוואטסאפ',
})
